import '../../../context.mjs';
import '../../action-item/action-item.dto.mjs';
import '../admin-user.dto.mjs';
import '../agency/agency.dto.mjs';
import '../agency/carrier-agency-relationships.dto.mjs';
import '../carrier/admin-carrier-preview.dto.mjs';
import '../company-credit-report.dto.mjs';
import '../company-credit-report-preview.dto.mjs';
import '../financial-period/admin-balance-sheet.dto.mjs';
import '../financial-period/admin-financial-period.dto.mjs';
import '../financial-period/admin-income-statement.dto.mjs';
import '../individual-credit-report.dto.mjs';
import '../individual-credit-report-preview.dto.mjs';
import '../individual-ofac-check.dto.mjs';
import '../individual-ofac-check-preview.dto.mjs';
import '../note/admin-note.dto.mjs';
import '../note/admin-note-topic.dto.mjs';
import '../pel-pml.dto.mjs';
import '../sfaa-class-experience.dto.mjs';
import '../surety/account/admin-account.dto.mjs';
import '../surety/account/admin-surety-account.dto.mjs';
import '../surety/account/bonding-line/admin-account-bonding-lines.dto.mjs';
import '../surety/account/contact/company-contact.dto.mjs';
import '../surety/account/contact/individual-contact.dto.mjs';
import '../surety/bond/admin-surety-bond.dto.mjs';
import '../surety/bond-form/surety-bond-form.dto.mjs';
import '../../surety/bond-number/bond-number.dto.mjs';
import '../surety/carrier-bonding-line/admin-surety-account-bonding-line.dto.mjs';
import '../surety/indemnity-agreement/surety-indemnity-agreement.dto.mjs';
import '../surety/quote/admin-quote.dto.mjs';
import '../surety/quote/surety-quote.dto.mjs';
import '../underwriter-assignment.dto.mjs';
import '../../agent/index.mjs';
import '../../carrier/carrier-preview.dto.mjs';
import '../../comment/comment.dto.mjs';
import '../../company/company.dto.mjs';
import '../../credit-report/company-credit-report.dto.mjs';
import '../../credit-report/individual-credit-report.dto.mjs';
import '../../decisioning/decisioning.dto.mjs';
import '../../email-ingest/email-ingest.dto.mjs';
import '../../entity-tag/index.mjs';
import '../../feature-flag/feature-flag.dto.mjs';
import '../../financial-extraction/financial-extraction.dto.mjs';
import '../../follower/follower.dto.mjs';
import '../../individual/individual.dto.mjs';
import '../../market-intelligence/fred.dto.mjs';
import '../../naics-code/index.mjs';
import '../../prompt-runner/application-extraction.dto.mjs';
import '../../prompt-runner/bond-request-extraction.dto.mjs';
import '../../prompt-runner/classification.dto.mjs';
import '../../prompt-runner/extraction.dto.mjs';
import '../../prompt-runner/report-brief.dto.mjs';
import '../../prompt-runner/webhook.dto.mjs';
import '../../report/render-report.dto.mjs';
import '../../sfaa-code/index.mjs';
import '../../surety/account/surety-account.dto.mjs';
import '../../surety/application-extraction/application-extraction.dto.mjs';
import '../../surety/bond/surety-bond.dto.mjs';
import '../../surety/bond/term/surety-bond-term.dto.mjs';
import '../../surety/bond-form/surety-bond-form.dto.mjs';
import '../../surety/bond-form/surety-bond-form-template.dto.mjs';
import '../../surety/bond-issuance/surety-bond-issuance.dto.mjs';
import '../../surety/bond-request-extraction/bond-request-extraction.dto.mjs';
import '../../surety/financial-period/financial-extraction-attach.dto.mjs';
import '../../surety/indemnity/indemnity-agreement.dto.mjs';
import '../../surety/quote/contract/contract-extraction.dto.mjs';
import '../../surety/quote/surety-quote.dto.mjs';
import '../../tag/index.mjs';
import '../../user/user.dto.mjs';
import '../../wip/extraction.dto.mjs';
import '../../wip/line-item.dto.mjs';
import '../../wip/project.dto.mjs';
import '../../wip/review.dto.mjs';
import '../../wip/statement.dto.mjs';
import { Get as Get$1 } from '../../wip-statement/wip-statement.dto.mjs';
import '../../../enums.mjs';
import '../../../types/actor/actor.mjs';
import '../../../types/address/address.mjs';
import '../../../types/credit-report/company-credit-report.mjs';
import '../../../types/credit-report/individual-credit-report.mjs';
import '../../../types/currency/currency.mjs';
import '../../../types/entityRelation/entity-relation.mjs';
import '../../../types/financial-formula/adjustable-value.mjs';
import '../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../types/financial-formula/adjustment.mjs';
import '../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../types/is-encrypted.mjs';
import '../../../types/naics-codes/naics-codes.mjs';
import '../../../types/opaque.mjs';
import '../../../types/surety/account/requested-limits.mjs';
import '../../../types/surety/account/surety-account.types.mjs';
import '../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../types/surety/application-extraction/application-review.mjs';
import '../../../types/surety/bond/surety-bond.types.mjs';
import '../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../types/surety/quote/surety-quote.types.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import { WorkInProgressStatement } from '../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../types/user/user.types.mjs';
import '../../../types/utils.mjs';
import 'ts-pattern';
import '../../../types/surety/account/bonding-line.mjs';
import '../../../utils/describe-fred-change.util.mjs';
import 'zod';
import 'luxon';
import '../../../utils/extractable-extension.util.mjs';
import '../../../utils/financial-analysis-metrics.util.mjs';
import '../../../utils/normalize-us-state.util.mjs';
import '../../../utils/validate-close-required-fields.util.mjs';
import '../../../utils/wip-extraction-readiness.util.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Get$1.Response.schema.omit({ files: true });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Create;
(function (Create) {
    (function (Request) {
        Request.schema = WorkInProgressStatement;
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = Create.Request.schema;
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Create, Get, Update };
